const types = {
  getters: {},
  actions: {},
  mutations: {},
  fields: {},
};

/**
 * Loader
 */
types.getters.isLoading = "isLoading";
types.getters.loadingText = "loadingText";
types.actions.setIsLoading = "setIsLoading";
types.mutations.setIsLoading = "setIsLoading";
types.mutations.setLoadingText = "setLoadingText";

/**
 * Dialog save and exit
 */
types.getters.isVisibleDialogSaveAndExit = "isVisibleDialogSaveAndExit";
types.actions.setIsVisibleDialogSaveAndExit = "setIsVisibleDialogSaveAndExit";
types.mutations.setIsVisibleDialogSaveAndExit = "setIsVisibleDialogSaveAndExit";

/**
 * Contacts
 */
types.getters.contacts = "contacts";
types.getters.contact = "contact";
types.getters.primaryContact = "primaryContact";
types.actions.updateContactField = "updateContactField";
types.actions.updateContactsRemote = "updateContactsRemote";
types.mutations.setContacts = "setContacts";
types.mutations.updateContactField = "updateContactField";
types.mutations.resetContactsDirtyFlag = "resetContactsDirtyFlag";

/**
 * Contact Bookings
 */
types.getters.contactBookings = "contactBookings";
types.getters.contactBooking = "contactBooking";
types.actions.updateContactBookingField = "updateContactBookingField";
types.mutations.setContactBookings = "setContactBookings";
types.mutations.updateContactBookingField = "updateContactBookingField";
types.mutations.resetContactBookingsDirtyFlag = "resetContactBookingsDirtyFlag";

/**
 * Bookings
 */
types.getters.booking = "booking";
types.getters.cruiseTicketURL = "cruiseTicketURL";
types.actions.searchBooking = "searchBooking";
types.actions.updateBookingField = "updateBookingField";
types.actions.updateBookingRemote = "updateBookingRemote";
types.actions.confirmBookingRemote = "confirmBookingRemote";
types.actions.sendCruiseTicketEmailRemote = "sendCruiseTicketEmailRemote";
types.mutations.setBooking = "setBooking";
types.mutations.updateBookingField = "updateBookingField";
types.mutations.resetBookingDirtyFlag = "resetBookingDirtyFlag";
types.mutations.setCruiseTicketURL = "setCruiseTicketURL";

/**
 * Cabin configurations
 */
types.getters.cabinConfigurations = "cabinConfigurations";
types.actions.updateCabinConfigurationField = "updateCabinConfigurationField";
types.actions.updateCabinConfigurationRemote = "updateCabinConfigurationRemote";
types.mutations.setCabinConfigurations = "setCabinConfigurations";
types.mutations.updateCabinConfigurationField = "updateCabinConfigurationField";
types.mutations.resetCabinConfigurationsDirtyFlag =
  "resetCabinConfigurationsDirtyFlag";

/**
 * Visa requirements
 */
types.getters.visaRequirements = "visaRequirements";
types.getters.visaRequirement = "visaRequirement";
types.getters.visaRequirementByContactID = "visaRequirementByContactID";
types.actions.updateVisaRequirementField = "updateVisaRequirementField";
types.actions.updateVisaRequirementsRemote = "updateVisaRequirementsRemote";
types.mutations.setVisaRequirements = "setVisaRequirements";
types.mutations.updateVisaRequirementField = "updateVisaRequirementField";
types.mutations.updateVisaRequirementEntity = "updateVisaRequirementEntity";
types.mutations.resetVisaRequirementsDirtyFlag =
  "resetVisaRequirementsDirtyFlag";

/**
 * Pre-arrangements
 */
types.getters.preArrangements = "preArrangements";
types.getters.preArrangement = "preArrangement";
types.getters.preArrangementByContactID = "preArrangementByContactID";
types.getters.preArrangementByContactIDAndCategory =
  "preArrangementByContactIDAndCategory";
types.actions.updatePreArrangementField = "updatePreArrangementField";
types.mutations.setPreArrangements = "setPreArrangements";
types.mutations.updatePreArrangementField = "updatePreArrangementField";
types.mutations.copyPreArrangement = "copyPreArrangement";

/**
 * Post-arrangements
 */
types.getters.postArrangements = "postArrangements";
types.getters.postArrangement = "postArrangement";
types.getters.postArrangementByContactID = "postArrangementByContactID";
types.getters.postArrangementByContactIDAndCategory =
  "postArrangementByContactIDAndCategory";
types.actions.updatePostArrangementField = "updatePostArrangementField";
types.mutations.resetPostArrangementAccommodationDetail =
  "resetPostArrangementAccommodationDetail";
types.mutations.resetPostArrangementFlightDetail =
  "resetPostArrangementFlightDetail";
types.mutations.resetPostArrangementPortToLocationDetail =
  "resetPostArrangementPortToLocationDetail";
types.mutations.setPostArrangements = "setPostArrangements";
types.mutations.updatePostArrangementField = "updatePostArrangementField";
types.mutations.copyPostArrangement = "copyPostArrangement";

/**
 * Passport Data
 */
types.getters.passports = "passports";
types.getters.passport = "passport";
types.getters.passportByContactID = "passportByContactID";
types.actions.updatePassportField = "updatePassportField";
types.actions.updatePassportsRemote = "updatePassportsRemote";
types.mutations.setPassports = "setPassports";
types.mutations.updatePassportField = "updatePassportField";
types.mutations.updatePassportEntity = "updatePassportEntity";
types.mutations.resetPassportsDirtyFlag = "resetPassportsDirtyFlag";

/**
 * Common
 */
types.getters.accessToken = "accessToken";
types.getters.expiryTime = "expiryTime";
types.getters.lastSaveTime = "lastSaveTime";
types.getters.isSaving = "isSaving";
types.getters.dietaryAllergies = "dietaryAllergies";
types.actions.updateContactsAndVisaRequirementsRemote =
  "updateContactsAndVisaRequirementsRemote";
types.actions.updateContactsAndBookingRemote = "updateContactsAndBookingRemote";
types.actions.updatePrePostArrangementsRemote =
  "updatePrePostArrangementsRemote";
types.actions.copyPrePostArrangement = "copyPrePostArrangement";
types.actions.setAccessToken = "setAccessToken";
types.actions.setLastSaveTime = "setLastSaveTime";
types.actions.setIsSaving = "setIsSaving";
types.actions.refreshAccessToken = "refreshAccessToken";
types.actions.logout = "logout";
types.actions.getDietaryAllergies = "getDietaryAllergies";
types.mutations.setExpiryTime = "setExpiryTime";
types.mutations.setAccessToken = "setAccessToken";
types.mutations.setLastSaveTime = "setLastSaveTime";
types.mutations.setIsSaving = "setIsSaving";
types.mutations.removeAccessToken = "removeAccessToken";
types.mutations.setDietaryAllergies = "setDietaryAllergies";

/**
 * Fields
 */
types.fields.pastTravelPeriod = {
  Amazon: "pastTravelPeriodForAmazon",
  Mekong: "pastTravelPeriodForMekong",
  Indonesia: "pastTravelPeriodForIndonesia",
};

export default types;



// WEBPACK FOOTER //
// ./src/store/types.js